
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import TableFilterable from '@/components/reports-v3/components/filterables/TableFilterable.vue';
import FilterWidget from '@/components/reports-v3/components/codedWidgets/shared/FilterWidget.vue';
import {PermissionsGroup} from '@/store/models.def';
import {getTableName} from '@/worker/db/sqlHelpers';
import gdbx from '@/store/modules/gdbx';
import moment from 'moment';
import { TableItemFormatter } from '../../elements/charts/helpers/tableItemFormatter';

@Component({
	components: {
		TableFilterable,
	},
})
export default class DashboardCustomerDueTable extends FilterWidget {
    public get permissionIds(): PermissionsGroup[] {
        return ['dashboard'];
    }

    public filterIds: Array<
		| 'date'
		| 'dateAsOf'
		| 'dateRange'
		| 'stockItems'
		| 'agents'
		| 'customers'
		| 'suppliers'
	> = ['dateAsOf'];

	public tableItems: any[] = [];
	public tableFields: any[] = [];

	public get exportFileName() {
		const formattedDate = moment(this.selectedAsOfDate).format('DD MMM YY');
		return 'Sales Agent Ranking' + '_' + formattedDate;
	}

	public get dateFormatted() {
		return this.selectedAsOfDate;
	}

	public get expensiveHook() {
		const { selectedAsOfDate } = this;
		return JSON.stringify([selectedAsOfDate]);
	}

	public async expensiveCalc() {
		this.generateLoadingText(0.2, 0.3);

		const mmtToday = moment(this.selectedAsOfDate).valueOf();
		const table = getTableName('dashboardApArDue');

		const jobId = this.currentJobId;
		const queryHead = await this._ensureTablesLoaded(['dashboardApArDue']);
		this.checkInterrupted(jobId);
		this.generateLoadingText(0.5);

		const rows = await queryHead.rawQuery(`
			SELECT "DOCTYPE", "DOCNO", "CODE", "COMPANYNAME",
				TRY_CAST("DOCDATE" AS BIGINT) as doc_date,
				TRY_CAST("DUEDATE" AS BIGINT) as due_date,
				"AGENT",
				TRY_CAST("LOCALDOCOSAMT" AS DOUBLE) as amount
			FROM ${table}
			WHERE "DOCTYPE" = 'IV'
				AND TRY_CAST("DUEDATE" AS BIGINT) <= ${mmtToday}
		`);
		this.checkInterrupted(jobId);

		this.tableFields = [
			{ key: 'age', sortable: true, stickyColumn: true },
			{ key: 'customer', sortable: true },
			{
				key: 'due_amount',
				sortable: true,
				formatter: TableItemFormatter.currencySplit,
			},
			{ key: 'sales_agent', sortable: true },
			{ key: 'doc_date', sortable: true },
			{ key: 'due_date', sortable: true },
			{ key: 'doc_no', sortable: true, stickyColumn: true },
		];

		this.tableItems = rows.map((row) => ({
			doc_no: row.DOCNO,
			customer: gdbx.customerNames[row.CODE],
			sales_agent: gdbx.agentNames[row.AGENT],
			due_amount: Number(row.amount) || 0,
			doc_date: moment(Number(row.doc_date)).format('DD/MM/yy'),
			due_date: moment(Number(row.due_date)).format('DD/MM/yy'),
			age: Math.ceil(moment.duration(mmtToday - Number(row.due_date)).asDays()),
		}));

		this.generateLoadingText(1);
		this.saveHistory('tableItems', 'tableFields');
	}
}
